const IconCircle: React.FunctionComponent<{}> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.10039 11.9999C3.10039 7.08457 7.08506 3.0999 12.0004 3.0999C16.9157 3.0999 20.9004 7.08457 20.9004 11.9999C20.9004 16.9152 16.9157 20.8999 12.0004 20.8999C7.08506 20.8999 3.10039 16.9152 3.10039 11.9999ZM12.0004 1.8999C6.42231 1.8999 1.90039 6.42183 1.90039 11.9999C1.90039 17.578 6.42231 22.0999 12.0004 22.0999C17.5785 22.0999 22.1004 17.578 22.1004 11.9999C22.1004 6.42183 17.5785 1.8999 12.0004 1.8999Z"
          fill="#6F7071"
        />
      </g>
    </svg>
  );
};

export default IconCircle;
